/** Revoked or expired — Edit and Revoke are disabled (detail stays viewable). */
export const isCredentialLocked = (status?: string | null): boolean =>
  status === 'revoked' || status === 'expired'

/**
 * Deliberately revoked — the terminal state. Gates Rotate: it stays available
 * for an expired credential (to revive it) and is blocked only once the
 * credential has been revoked.
 */
export const isCredentialRevoked = (status?: string | null): boolean =>
  status === 'revoked'
